<template>
  <div>
    <div class="chat-window-header" :style="$styles.chatWindowHeaderContainer()">
      <img
        v-if="theme.logo.src && displayLogo"
        :src="theme.logo.src"
        alt="Chat logo icon"
        class="chat-window-header-icon"
        :style="$styles.chatWindowHeaderLogo()"
      />
      <div>
        <h5 class="chat-window-header-title-text" :style="$styles.chatWindowHeaderText()">{{ title }}</h5>
      </div>
      <div class="chat-window-header-title-text close-wrapper">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjM0MzggOUwxNy4wMzEyIDQuMzEyNUMxNy42NDA2IDMuNzUgMTcuNjQwNiAyLjgxMjUgMTcuMDMxMiAyLjI1TDE2IDEuMjE4NzVDMTUuNDM3NSAwLjYwOTM3NSAxNC41IDAuNjA5Mzc1IDEzLjkzNzUgMS4yMTg3NUw5LjI1IDUuOTA2MjVMNC41MTU2MiAxLjIxODc1QzMuOTUzMTIgMC42MDkzNzUgMy4wMTU2MiAwLjYwOTM3NSAyLjQ1MzEyIDEuMjE4NzVMMS40MjE4OCAyLjI1QzAuODEyNSAyLjgxMjUgMC44MTI1IDMuNzUgMS40MjE4OCA0LjMxMjVMNi4xMDkzOCA5TDEuNDIxODggMTMuNzM0NEMwLjgxMjUgMTQuMjk2OSAwLjgxMjUgMTUuMjM0NCAxLjQyMTg4IDE1Ljc5NjlMMi40NTMxMiAxNi44MjgxQzMuMDE1NjIgMTcuNDM3NSAzLjk1MzEyIDE3LjQzNzUgNC41MTU2MiAxNi44MjgxTDkuMjUgMTIuMTQwNkwxMy45Mzc1IDE2LjgyODFDMTQuNSAxNy40Mzc1IDE1LjQzNzUgMTcuNDM3NSAxNiAxNi44MjgxTDE3LjAzMTIgMTUuNzk2OUMxNy42NDA2IDE1LjIzNDQgMTcuNjQwNiAxNC4yOTY5IDE3LjAzMTIgMTMuNzM0NEwxMi4zNDM4IDlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
          alt="default"
          class="close-icon"
          @click="closeChat"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    displayLogo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    theme() {
      return this.$theme.getActiveTheme().header
    },
  },
  methods: {
    closeChat() {
      this.$emit('close-chat')
    },
  },
}
</script>

<style scoped>
.chat-window-header {
  background-color: rgb(0, 0, 0);
  min-height: 75px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  padding: 10px;
  -webkit-box-shadow: 0 1px 4px rgb(0 0 0 / 20%);
  box-shadow: 0 1px 4px rgb(0 0 0 / 20%);
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
}

.chat-window-header-icon {
  align-self: center;
  height: 40px;
}

.chat-window-header-title-text {
  align-self: center;
  padding: 10px;
  font-size: 20px;
  margin: 0px;
}

.close-wrapper {
  padding-bottom: 7px;
}

.close-icon {
  cursor: pointer;
}
</style>
